


 const  Error= ()=> {
    return (
        <> <div> <h1> Page not found </h1></div></>
    )
}


export default Error